export default __webpack_public_path__ + "static/media/reshet13-black.c8cc86ac.svg";